const DEFAULT_EVENT_SAMPLE_RATE = 0.1;
const DEFAULT_PROFILE_EVENT_VERSION = '2.0';

export type AppPerfCaptureConfig = {
	enabled: boolean;
	sampleRate: number;
	version?: string;
};

export const defaultPerfCaptureConfig: AppPerfCaptureConfig = {
	enabled: true,
	sampleRate: DEFAULT_EVENT_SAMPLE_RATE,
	version: DEFAULT_PROFILE_EVENT_VERSION,
};

// Modules that should have performance profiles collected.
export const enabledModulesForPerfCapture: string[] = [
	// Jira modules
	'jira:adminPage',
	'jira:customField',
	'jira:customFieldType',
	'jira:dashboardGadget',
	'jira:globalPage',
	'jira:issueAction',
	'jira:issueActivity',
	'jira:issueContext',
	'jira:issuePanel',
	'jira:projectPage',
	'jira:projectSettingsPage',
	'jira:uiModifications',

	// Confluence modules
	'confluence:contentAction',
	'confluence:contentBylineItem',
	'confluence:globalPage',
	'confluence:globalSettings',
	'confluence:spacePage',
	'xen:macro',
];
